<div class="main-footer">
  Powered by Cavallino Bianco Family Spa Grand Hotel {{year}}
</div>
